import ThreeColumnDemo, { ThreeColumnDemoProps } from '@/components/_rebrand/ThreeColumnDemo';
import SerifAndSansSerifHeadline from '@/components/_rebrand/craft/product/_organisms/SerifAndSansSerifHeadline';
import { parseHtml } from '@/lib/parse-html';
import Image from 'next/image';

const displayProps = {
  title: null,
  features: [],
  styleOverrides: undefined,
} as ThreeColumnDemoProps;

interface AssetImageFromCraft {
  url: string;
  title: string;
  alt: string;
  width: number;
  height: number;
}

interface ReasonFromCraft {
  headline: string;
  icon: AssetImageFromCraft;
  description: string;
}

const formReasons = (reasons: ReasonFromCraft[]): ThreeColumnDemoProps['features'] => {
  const cards: ThreeColumnDemoProps['features'] = reasons.map((reason) => ({
    icon: <Image src={reason.icon[0].url} width={reason.icon[0].width} height={reason.icon[0].height} style={{ width: 16 }} alt={reason.icon[0].title} />,
    title: reason.headline,
    description: parseHtml(reason.description),
  }));

  return cards;
}

const setDynamicDisplayPropAttributes = (entry: any) => {
  displayProps.title = <SerifAndSansSerifHeadline primarySansSerif={entry.headerSansSerif} secondarySerif={entry.headerSerif} lineBreak={true} />
  displayProps.features = formReasons(entry.reasons);
  displayProps.styleOverrides = {
    bottomMarginSpacing: 'none',
    topMarginSpacing: 'none'
  };
}

const WhyFront = ({ entry }) => {
  if (entry.__typename != 'comparisonModules_whyFront_BlockType') {
    return null;
  }

  setDynamicDisplayPropAttributes(entry);
  return (
    <div className="bg-violet-100 pt-2 border border-solid border-violet-100">
      <ThreeColumnDemo {...displayProps} />
    </div>
  );
};

export default WhyFront;
